exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#event-popup[data-v-440cfeed] {\n  position: absolute;\n  z-index: 1000;\n  top: 8px;\n  left: 30px;\n  padding: 0 15px;\n}\n#event-popup.sticky-stick[data-v-440cfeed] {\n  position: -webkit-sticky;\n  position: sticky;\n}\n.fix-width[data-v-440cfeed] {\n  min-width: 200px;\n  max-width: 200px;\n}\n.close-popup[data-v-440cfeed] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  margin-top: 11px;\n  margin-right: 2px;\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  text-align: center;\n  line-height: 30px;\n  color: #FE2B41;\n  font-weight: bold;\n  background: none;\n  border: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-440cfeed","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/display/CampaignCalendar.vue
// module id = ng7C
// module chunks = 53